module.exports = __webpack_public_path__ + "static/media/nb_akademie_regular-webfont.67320edf.ttf";